import '../styles/thanks.scss'
import ReactGA from 'react-ga';

const Thanks = ({close, open}) => {
    return(
        <div className="thanks-container">
            <h1 className="title headline">
                Thank you for voting!
            </h1>
            <p className="title" style={{fontSize: "2em", padding: '1em 0em'}}>You can vote once per day from September 27, 10:00 AM PDT to October 12, 12:00 PM PDT.</p>
            <p className="title">Preorder Prinny Presents NIS Classics Volume 2: Makai Kingdom: Reclaimed and Rebound / ZHP: Unlosing Ranger VS Darkdeath Evilman</p>
            <div className="title-wrapper">
                <h1 className="makai">Limited Edition</h1>
            </div>
            <div className="store">
                <img src="./img/glam/LE.jpg" alt="LE" className="glam"/>              
                <div className="links">
                    <a href="https://store.nisamerica.com/prinny-presents-nis-classics-volume-2-makai-kingdom-zhp-limited-edition-nintendo-switch" target="_blank" rel="noopener noreferrer">
                        <button className="submit" onClick={()=>{
                            ReactGA.event({
                                category: 'Link',
                                action: 'Click',
                                label: 'Learn More'
                            })
                        }}>NISA Online</button>
                    </a>
                </div>
            </div>
            <div className="title-wrapper">
                <h1 className="zhp">Deluxe Edition</h1>
            </div>
            <div className="store last">
                <img src="./img/glam/DE.jpg" alt="LE" className="glam" />
                <div className="links">
                    <a href="https://store.nisamerica.com/prinny-presents-nis-classics-volume-2-makai-kingdom-zhp-limited-edition-nintendo-switch" target="_blank" rel="noopener noreferrer">
                        <button className="submit">Coming soon</button>
                    </a>
                </div>
            </div>
            <div className="links">
                <button className="submit" onClick={
                    ()=>{
                        close()
                        open()
                    }
                }>See Results</button>
            </div>
        </div>
    )
}

export default Thanks;